import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiSettings, FiShoppingBag } = FiIcons;

const AdminHeader = () => {
  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center">
            <motion.div
              whileHover={{ scale: 1.05 }}
              className="flex items-center"
            >
              <SafeIcon icon={FiShoppingBag} className="h-8 w-8 text-blue-600 mr-2" />
              <span className="text-xl font-bold text-gray-900">FileStore Admin</span>
            </motion.div>
          </Link>

          <div className="flex items-center">
            <SafeIcon icon={FiSettings} className="h-5 w-5 text-gray-400 mr-2" />
            <span className="text-sm text-gray-600">Administrative Panel</span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;